<template>
  <div class="order-item">
    <div class="shop-con">
      <div class="shop-img-con"><img class="shop-img" :src="item.mapShopInfo.shopAvatar + '?imageView2/0/w/80/h/80'" alt=""></div>
      <div class="shop-name">{{ item.mapShopInfo.shopName }}</div>

    </div>
    <div class="order-body">
      <div class="only-one" v-if="item.shopItems.length===1">
        <goods-list :item2="item.shopItems[0]"></goods-list>
      </div>
      <div class="no-only-one" v-if="item.shopItems.length>1">
        <div class="img-con">
          <div class="img-list">
            <div class="img-con-item" v-for="(item2, i2) in item.shopItems" :key="item2.productCode">
              <img class="img" :src="'http://img13.360buyimg.com/n2/'+item2.mapProductDetail.coverImage" alt="">
            </div>
          </div>
        </div>
        <div class="right-con" @click="openGoodsList">
          <div class="icon"></div>
        </div>
      </div>
    </div>

    <div class="bg-10px"></div>
  </div>
</template>

<script>
import goodsList from './goodsList'
export default {
  components: {
    goodsList
  },
  props: {
    itemData: {
      required: true
    },
    shopKey: {
      required: true
    }
  },
  watch: {
    itemData: {
      handler(newData, oldData) {
        this.item = Object.assign({}, newData)
        this.goodsList = Object.assign([], newData.shopItems)
      },
      deep:true,
      immediate: true
    },
  },
  data(){
    return {
      item: {},
      goodsList: [],
    }
  },
  methods: {
    openGoodsList(){
      this.$emit('openGoodsListCon', this.shopKey)
    },
  }
}
</script>

<style lang="less" scoped>
@url: '../../../../../assets/my/';
.order-item{
  font-size: 14px;
  .shop-con{
    display: flex;width: 100%;height: 46px;border-bottom: 1px solid #edecec;
    .shop-img-con{
      width: 48px;height: 100%;display: inline-flex;justify-content: center;align-items: center;
      .shop-img{
        display: block;width: 24px;height: 24px;border-radius: 50%;
      }
    }
    .shop-name{
      flex: 1;height: 100%;color: #2b2b2b;font-size: 14px;
      display: inline-flex;justify-content: flex-start;align-items: center;

    }

  }
  .order-body{
    width: 100%;height: 115px;border-bottom: 1px solid #edecec;
    .only-one{}
    .no-only-one{
      padding: 15px 0 15px 12px;
      display: flex;position: relative;
      .img-con{
        width: 327px;height: 85px;overflow: hidden;
        position: relative;z-index: 0;
        .img-list{
          position: absolute;z-index: 0;display: flex;
          top: 0;left: 0;right: 0;bottom: -12px;
          overflow-y: hidden;overflow-x: auto;
          .img-con-item{
            display: inline-flex;
            width: 85px;height: 85px;margin-right: 10px;
            flex-grow:0;flex-shrink:0;
            .img{width: 100%;height: 100%;display: block;border-radius: 8px;}
          }
        }
      }
      .right-con{
        width: 36px;height: 85px;
        display: inline-flex;justify-content: center;align-items: center;
        .icon{
          display: block;width: 8px;height: 16px;
          background: url("@{url}icon-right.png") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
    }
  }

}
</style>